import { DebugTimelineComponent } from '@/pages/DebugTimelineComponent';
import { Toaster, TooltipProvider } from 'debug-time-machine-ui';

function App() {
  return (
    <TooltipProvider>
      <div className='App'>
        <DebugTimelineComponent />
        <Toaster />
      </div>
    </TooltipProvider>
  );
}

export default App;
